export interface IPermissionOption<T> {
  label: string;
  item: T;
}

export interface IPermissionGroup<T> {
  /** Nome antes de " - " na descrição (ex.: "Colaboradores"); null quando não há prefixo. */
  title: string | null;
  options: IPermissionOption<T>[];
}

const SEPARATOR = ' - ';

/**
 * Agrupa as permissões de uma funcionalidade pelo prefixo da descrição, para a tela de perfis
 * mostrar "Colaboradores" como subtítulo e "List", "Export" como opções. Grupos e opções em
 * ordem alfabética, porque a API devolve as permissões sem ordem.
 */
export function groupPermissions<T extends { description: string }>(items: T[]): IPermissionGroup<T>[] {
  const groups = new Map<string | null, IPermissionOption<T>[]>();

  for (const item of items) {
    const index = item.description.indexOf(SEPARATOR);
    const title = index > 0 ? item.description.slice(0, index) : null;
    const label = index > 0 ? item.description.slice(index + SEPARATOR.length) : item.description;

    groups.set(title, [...(groups.get(title) ?? []), { label, item }]);
  }

  return [...groups.entries()]
    .map(([title, options]) => ({ title, options: options.sort((a, b) => a.label.localeCompare(b.label)) }))
    .sort((a, b) => (a.title ?? '').localeCompare(b.title ?? ''));
}
